import React, { Component } from "react";

import { CCard, CCardHeader, CCardBody } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import ProtectedRoute from "../../../components/ProtectedRoute";
import PageCurriculum from "../../../components/Statistics/StatisticsAccess/PageCurriculum";

class Report extends Component {
  render() {
    return (
      <div className="d-flex flex-column align-items-left">
        <Breadcrumb current={this.props.currentRoute} />
        <CCard>
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <h4 className="card-title mb-1">Relatório de Currículo</h4>
              <div className="small text-muted">
                Monitore o progresso dos currículos
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            <PageCurriculum user={this.props.user} />
          </CCardBody>
          <ProtectedRoute routeId={this.props.currentRoute} />
        </CCard>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Report);
